// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"ContentLimiter_buttonContainer__ln_x9","line":"ContentLimiter_line__jlc_3"};